<template>
  <v-form class="mx-10 mb-10 pa-10 text-center"
    ref="form"
    v-model="valid"
    lazy-validation>
    <h3 class="text-left mb-5 text-primary">Initialize Profile</h3>
    <v-layout>
      <v-flex md4>
        <v-select background-color="rgba(255,255,255)"
                  v-model="selectedKeyStoreId"
                  item-text="id"
                  item-value="id"
                  label="keyStoreId"
                  @change="keyStoreChanged"
                  outlined dense
                  :items="keyStoreIdsList"
        ></v-select>
        <v-autocomplete background-color="rgba(255,255,255)"
                        v-model="selectedProfile"
                        :items="profileList"
                        item-text="friendlyName"
                        item-value="name"
                        label="Profile"
                        outlined
                        dense
        ></v-autocomplete>
        <v-divider></v-divider>
        <v-textarea 
        background-color="#999999"  
                    name="input-7-1"
                    label="Parameters"
                    class="mt-10"
                    no-resize
                    height="150px"
                    v-model="requestPayload"
                    outlined
        ></v-textarea>
      </v-flex>
      <v-flex md2>
        <v-btn class="mx-2"
               color="#007CA4"
               @click="initializeProfile"
               dark
               :disabled="!valid">
          Initialize profile >>
        </v-btn>
      </v-flex>
      <v-flex md6>
        <v-textarea background-color="rgba(255,255,255)"
                    name="input-7-1"
                    label="Response"
                    no-resize
                    height="550px"
                    v-model="response"
                    outlined
        ></v-textarea>
      </v-flex>
    </v-layout>
  </v-form>
</template>
<script>
import { mapMutations } from 'vuex'
import alisonJS from  '@/services/alison_js.js'
  export default {
    props:['keyStoreIds', 'keyStoreInfo', 'keyStoreId', 'data'],
    data: () => ({
      requestPayload: '{}',
      selectedKeyStoreId: "",
      selectedProfile: "",
      keyStoreIdsList: [],
      profileList: [],
      response: "",
      valid: false
    }),
    watch:{
      keyStoreId(){
        this.selectedKeystoreId = this.keyStoreId;
      },
      keyStoreInfo(){
        this.profileList.push({friendlyName: 'none', name:''})
        this.keyStoreInfo.forEach(elem => this.profileList.push(elem))
      },
      selectedProfile(value){
        this.updatePayload('keyStore','profile', value)
      }
    },
    mounted() {
      this.loadKeyStores()
      //this.keyStoreIdsList = this.keyStoreIds.filter((key)=>key.capabilities.includes('G'));
      this.selectedKeyStoreId = this.keyStoreIdsList.find((key)=>key.id === this.keyStoreId) ? this.keyStoreId : null;
      if (this.selectedKeyStoreId) {
        const _keystore = this.keyStoreIdsList.filter((key)=>key.id === this.selectedKeyStoreId)[0];
        this.updatePayload('keyStore','id', this.selectedKeyStoreId)
        if (keystore.keyStoreType !== "TOKEN")
          this.profileList.push({friendlyName: 'new profile', name:''})
      }
      this.keyStoreInfo.forEach(elem => this.profileList.push(elem))
    },
    methods: {
      ...mapMutations({
        setSnack: 'setSnack',
        setColor: 'setColor'
      }),
      keyStoreChanged(){
        this.updatePayload('keyStore','id',this.selectedKeyStoreId)
        this.selectedProfile = null
        this.getKeyStoreInfo(this.selectedKeyStoreId)
      },

      initializeProfile(){
        alisonJS.initializeProfile(JSON.parse(this.requestPayload)).then((result)=>{
          this.response = JSON.stringify(result, null , "\t")
        }, (e) => {
          this.setColor('error')
          if(e.code && (e.detail || e.message)){
              if(e.message){ this.setSnack('ERROR ' + e.message) }
              else { this.setSnack('ERROR '+ e.code +': ' + e.detail) }
          }else{
            this.setSnack('FAILURE: ' + JSON.stringify(e))
          }
          this.response = JSON.stringify(e, null, "\t");
        })   
      },
      getKeyStoreInfo(keyStoreId) {
        this.profileList = []
        alisonJS.keyStoreInfo({id:keyStoreId}).then((info) => {
          this.setColor('info'); this.setSnack('KeyStore info obtained successfully');

          const _keystore = this.keyStoreIdsList.filter((key)=>key.id === keyStoreId)[0];
          if(_keystore && _keystore.keyStoreType !== "TOKEN") this.profileList.push({friendlyName: 'new profile', name:''})
          info.keyStores.forEach(ks => {
            this.profileList = this.profileList.concat(ks.profiles)
          });
        }).catch(e=>{
            this.setColor('error'); this.setSnack('FAILURE: ' + JSON.stringify(e))
        })
      },
      loadKeyStores() {
        alisonJS.listKeyStores().then((list) => {
              this.keyStoreIdsList = list.keyStores.filter((key)=>key.capabilities.includes('G'));
              this.setColor('success'); this.setSnack('KeyStores obtained successfully')
          }).catch((e)=>{
            console.log("error:", e)
            this.setColor('error')
            if(e.code && (e.detail || e.message)){
              if(e.message){ this.setSnack('ERROR ' + e.message) }
              else { this.setSnack('ERROR '+ e.code +': ' + e.detail) }
            }else{
              this.setSnack('FAILURE: ' + JSON.stringify(e))
            }
            this.response = JSON.stringify(e, null, "\t");
          })
      },
      updatePayload(key1, key2, param){
        let request = JSON.parse(this.requestPayload)
        if (key2) {
          if (!request[key1]) request[key1] = {}
          request[key1][key2] = param;
        }else{
          request[key1] = param;
        }
        this.requestPayload = JSON.stringify(request, null, "\t");
      }
    }
  }
</script>